module.exports = __webpack_public_path__ + "static/images/fill-high.e214cf3148f2e715c338d2453824b050.svg";